import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import TranslateButton from './components/TranslateButton';

export default function () {
  extend(TextEditor.prototype, 'controlItems', function (items) {
    // 从本地存储读取设置
    const savedSettings = localStorage.getItem('tf-translate-settings');
    const settings = savedSettings ? JSON.parse(savedSettings) : { enabled: '1' };
    const isEnabled = settings.enabled === '1';
    
    if (!isEnabled) {
      return;
    }

    // 添加翻译按钮（已集成语言选择功能）
    items.add(
      'tf-translate',
      TranslateButton.component({
        editor: this,
      }),
      -1
    );
  });
}
